/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStyles, makeStyles } from '@material-ui/core';
import type { Theme } from '@material-ui/core/styles';

const SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

function generateStyles(theme: Theme) {
    const styles: any = {};

    SPACINGS.forEach((spacing) => {
        styles[`width-spacing-${spacing}`] = {
            width: `${theme.spacing(spacing)}px`,
            height: '0px',
            minWidth: `${theme.spacing(spacing)}px`,
            minHeight: '0px',
        };

        styles[`height-spacing-${spacing}`] = {
            width: '0px',
            height: `${theme.spacing(spacing)}px`,
            minWidth: '0px',
            minHeight: `${theme.spacing(spacing)}px`,
        };
    });

    return styles;
}

const styles = (theme: Theme) =>
    createStyles({
        root: {
            display: 'block',
        },
        ...generateStyles(theme),
    });

export default makeStyles(styles, { name: 'MuiSpace' });
